const pt = {
  // Landing
  landingHeroTitle: "Descubra follows suspeitos. Pare de adivinhar.",
  landingHeroSubtitle: "Veja quem seu parceiro, crush ou amigos seguiram recentemente. Receba alertas de novos follows e unfollows. 100% anônimo.",
  landingHeroPlaceholder: "Digite o @usuario para analisar",
  landingHeroCta: "Analisar perfil",
  landingHowItWorks: "Como funciona",
  landingStep1Title: "Digite o usuário",
  landingStep1Body: "Informe o perfil do Instagram que você deseja analisar.",
  landingStep2Title: "Rastreamos novos follows",
  landingStep2Body: "Nosso sistema mapeia as conexões mais recentes e organiza tudo em uma linha do tempo clara.",
  landingStep3Title: "Receba alertas de mudanças",
  landingStep3Body: "Fique sabendo imediatamente sempre que o perfil seguir ou deixar de seguir alguém.",
  landingComparisonTitle: "Checagem manual vs. Monitoramento automático",
  landingComparisonManual: "Checagem manual",
  landingComparisonManualDesc: "Abra o Instagram, busque o perfil, role a lista de seguindo tentando lembrar quem é novo.",
  landingComparisonAutomated: "Monitoramento Stalkie",
  landingComparisonAutomatedDesc: "Detectamos mudanças automaticamente. Novos follows, unfollows e alterações nas listas de quem seguem.",
  landingReliabilityTitle: "Como funciona a coleta de dados?",
  landingReliabilityBody: "Consultamos dados para rastrear mudanças nos perfis. Embora busquemos precisão, observe as regras do serviço:",
  landingReliability1: "Usamos requisições seguras para atualizar a linha do tempo",
  landingReliability2: "Não é possível rastrear perfis privados",
  landingReliability3: "Atualizações na plataforma podem influenciar a frequência de checagem",
  landingReliability4: "Mostramos apenas os follows e unfollows novos detectados a partir do início",
  landingReliabilityCta: "Garantimos total anonimato: o perfil alvo nunca saberá que você está verificando.",
  landingFaqTitle: "Perguntas frequentes",
  landingFaq1Q: "Preciso fazer login no meu Instagram?",
  landingFaq1A: "Não. O Stalkie funciona de forma 100% anônima e independente. Você nunca precisa fornecer sua senha ou conectar sua conta.",
  landingFaq2Q: "Consigo monitorar contas privadas?",
  landingFaq2A: "Não. Apenas monitoramos perfis públicos do Instagram. Perfis privados não podem ser rastreados e respeitamos as configurações de privacidade do Instagram.",
  landingFaq3Q: "Com que frequência as atualizações acontecem?",
  landingFaq3A: "Checamos o perfil regularmente de acordo com o plano de assinatura selecionado e enviamos alertas de mudanças.",
  landingFaq4Q: "Vou ver o histórico de follows antes do monitoramento?",
  landingFaq4A: "Mostramos os follows atuais. O histórico e os alertas de novas conexões começam a ser gerados a partir do momento em que o rastreamento é ativado.",
  landingFaq5Q: "O perfil alvo vai saber que estou de olho?",
  landingFaq5A: "Não. O monitoramento é feito pelos nossos servidores de forma totalmente anônima. Nenhuma notificação ou aviso é enviado ao perfil verificado.",
  landingCtaTitle: "Quer saber a verdade?",
  landingCtaBody: "Digite o @usuario abaixo para revelar as últimas conexões e novos follows.",
  landingDisclaimer: "Stalkie é um serviço independente de monitoramento e não possui filiação ou patrocínio com o Instagram ou Meta.",

  // Search
  searchTitle: "Rastreando conexões",
  searchSubtitle: "Verificando histórico recente de @%{handle}",
  previewAnalyzingTitle: "Analisando follows",
  previewProgressLabel: "Progresso",
  searchLoading1: "Preparando conexão segura...",
  searchLoading2: "Localizando perfil...",
  searchLoading3: "Analisando perfil...",
  searchLoading4: "Montando seu relatório...",
  searchLoading5: "Finalizando visualização segura...",
  searchErrorInvalid: "Usuário inválido. Use letras, números, underscores e pontos.",
  searchErrorEmpty: "Por favor, digite um usuário do Instagram.",
  searchErrorProvider: "Nosso provedor de dados está temporariamente indisponível. Tente novamente mais tarde.",
  searchErrorRateLimit: "Muitas requisições. Aguarde um momento e tente novamente.",
  searchErrorNotFound: "Perfil não encontrado. Verifique o nome e tente novamente.",
  searchErrorGeneric: "Algo deu errado. Tente novamente.",
  validationEmpty: "Por favor, digite um usuário do Instagram.",
  validationInvalidProviderUrl: "Use um link de perfil do instagram.com ou um nome de usuário.",
  validationInvalidUrl: "Use um link de perfil do Instagram ou um nome de usuário válido.",
  validationSpacesOrAt: "Nomes de usuário não podem conter espaços ou símbolos @ extras.",
  validationLengthOrChars: "Use de 1 a 30 letras, números, sublinhados ou pontos.",
  downloadIos: "Baixar para iOS",
  downloadAndroid: "Baixar para Android",
  scanToDownload: "Escaneie para baixar",

  // Profile preview
  previewTitle: "@%{handle}",
  previewPublicAvailable: "Perfil disponível — Rastreamento pronto",
  previewPrivateNotAvailable: "Perfil privado — não pode ser monitorado",
  previewNotFound: "Perfil não encontrado",
  previewPrivateNote: "Ao contrário de outros aplicativos, o Stalkie não acessa contas privadas do Instagram, e isso é por design.",
  previewNotFoundBody: "Verifique a escrita do usuário e tente novamente. Certifique-se de que é um nome de usuário válido do Instagram.",
  previewFollowingCount: "%{count} seguindo",
  previewFollowersCount: "%{count} seguidores",
  previewVerified: "Verificado",
  previewLastChecked: "Última verificação: %{time}",
  previewReliabilityLabel: "Confiança dos dados: %{level}",
  previewBaselineTitle: "Conexões recentes",
  previewBaselineBody: "Estes são alguns dos perfis que o usuário segue atualmente.",
  previewLockedTitle: "Desbloquear monitoramento de follows",
  previewLockedBody: "Assine para monitorar este perfil. Você receberá alertas no seu celular sempre que ele seguir ou deixar de seguir alguém.",
  previewLockedCta: "Ver planos",
  previewNoDataTitle: "Nenhum dado disponível",
  previewNoDataBody: "Não foi possível obter dados para este perfil. Pode ser privado ou estar temporariamente indisponível.",
  previewWhatYouGet: "O que você recebe com o monitoramento:",
  previewFeature1: "Detecção automática de novos follows",
  previewFeature2: "Detecção automática de unfollows",
  previewFeature3: "Linha do tempo organizada por data",
  previewFeature4: "Alertas automáticos de mudanças",
  previewFeature5: "Análise de gênero dos novos follows",
  previewMonitoringStartsAfter: "O rastreamento de histórico começa após você iniciar o monitoramento. Mudanças passadas não estão disponíveis.",
  previewWhatDoYouThink: "O que você acha? 🤔",
  previewRecentlyFollowed: "%{name} seguiu recentemente",
  previewGirlsCount: "%{count} garotas",
  previewGirlCount: "%{count} garota",
  previewGuysCount: "%{count} garotos",
  previewGuyCount: "%{count} garoto",
  previewOthersCount: "%{count} outros",
  previewOtherCount: "%{count} outro",
  previewUnlockNow: "Desbloquear agora",
  previewAuthenticatedTitle: "Pronto para monitorar",
  previewAuthenticatedBody: "Adicione este perfil ao seu monitoramento e receba alertas quando houver mudanças.",
  previewAddMonitoring: "Adicionar monitoramento",
  previewContinueToReview: "Continuar",
  searchPageKicker: "Visualização de perfil público",
  searchPageSubtitle: "Pesquise qualquer usuário público do Instagram para ver a disponibilidade do perfil antes de monitorá-lo.",
  searchPageEnterHandle: "Digite um usuário para começar",
  searchPageEnterHandleDesc: "Use a busca acima para verificar um perfil público e ver uma visualização bloqueada.",
  searchPageValidating: "Validando @%{handle} antes de verificar os dados públicos.",
  previewingHandle: "Visualizando @%{handle}",
  previewPageSubtitle: "Continue pesquisando perfis públicos e compare as visualizações antes de assinar.",
  
  reliability_reliable: "Perfil disponível",
  reliability_reliable_desc: "Este perfil é público e está pronto para ser monitorado.",
  reliability_probably_reliable: "Perfil disponível",
  reliability_probably_reliable_desc: "Este perfil é público e está pronto para ser monitorado.",
  reliability_confirmation_required: "Verificando perfil",
  reliability_confirmation_required_desc: "Verificando status do perfil e atualizações recentes.",
  reliability_degraded: "Perfil disponível",
  reliability_degraded_desc: "Este perfil é público e está pronto para ser monitorado.",
  reliability_incomplete_data: "Dados indisponíveis",
  reliability_incomplete_data_desc: "Não foi possível recuperar informações suficientes para este perfil.",
  reliability_provider_error: "Temporariamente indisponível",
  reliability_provider_error_desc: "A busca está temporariamente indisponível. Tente novamente mais tarde.",
  reliability_private_profile: "Perfil privado",
  reliability_private_profile_desc: "Este perfil é privado. Só podemos monitorar perfis públicos do Instagram.",
  reliability_paused_unreliable: "Indisponível",
  reliability_paused_unreliable_desc: "O monitoramento está temporariamente indisponível.",
  reliability_unknown: "Verificando status",
  reliability_unknown_desc: "Verificando o status do perfil.",
  // Paywall
  paywallTitle: "Desbloquear monitoramento de @%{handle}",
  paywallSubtitle: "Receba notificações em tempo real sempre que este perfil seguir ou deixar de seguir alguém.",
  paywallPlanWeekly: "Semanal",
  paywallPlanMonthly: "Mensal",
  paywallBestValue: "Melhor valor",
  paywallTitleTarget: "Continue acompanhando @%{handle}",
  paywallSubtitleTarget: "Receba alertas quando @%{handle} seguir alguém novo. Nós continuamos monitorando para que você não precise verificar manualmente.",
  paywallProfilesFollowing: "Perfis que @%{handle} segue",
  paywallFeaturePrivateTitle: "100% privado e seguro",
  paywallFeaturePrivateDesc: "Não exige login do seu Instagram",
  paywallFeatureRecentTitle: "Ver novos follows em ordem",
  paywallFeatureRecentDesc: "Veja exatamente quem o perfil seguiu, ordenado por data",
  paywallFeatureNotifiedTitle: "Alertas de cada mudança",
  paywallFeatureNotifiedDesc: "Notificações instantâneas de novos follows e unfollows",
  paywallTrusted: "Confiado por mais de 1 milhão de usuários",
  paywallCancelAnytime: "Cancele a qualquer momento, sem compromissos",
  paywallNotNow: "Agora não",
  paywallPlanWeeklyDesc: "Menor compromisso, acesso completo",
  paywallPlanMonthlyDesc: "Os mesmos recursos, por mais tempo",
  paywallMonitorLimit: "Até %{count} perfis",
  paywallCta: "Começar monitoramento",
  paywallRestore: "Restaurar compra",
  paywallRestoring: "Restaurando...",
  paywallRestoreSuccess: "Compra restaurada. Sua assinatura está ativa.",
  paywallRestoreNotFound: "Nenhuma compra ativa foi encontrada para esta conta.",
  paywallRestoreError: "Não foi possível restaurar a compra. Tente novamente.",
  paywallTerms: "Ao continuar, você concorda com nossos Termos de Uso e Política de Privacidade.",
  paywallBillingNote: "Cobrança recorrente. Cancele quando quiser.",
  paywallPerDay: "Menos de %{price} por dia",

  paywallBillingPeriodWeekly: "semana",
  paywallBillingPeriodMonthly: "mês",
  paywallErrorStartMonitoring: "Não foi possível iniciar o monitoramento. Tente novamente.",
  paywallErrorLoad: "Não foi possível carregar os planos. Tente novamente.",
  paywallActivatingPlan: "Ativando seu plano...",
  paywallMonitorSetupFailedTitle: "Monitoramento não iniciado",
  paywallMonitorSetupFailedBody: "Seu plano está ativo, mas não conseguimos iniciar o monitoramento deste perfil. Tente novamente.",
  paywallProcessingPaymentTitle: "Processando pagamento...",
  paywallProcessingPaymentBody: "Seu pagamento pode levar alguns instantes para processar. Se você não for redirecionado, confira o recibo no e-mail.",
  paywallSuccessTitle: "Tudo certo",
  paywallSuccessBody: "Levando você para a visão geral...",
  paywallSettingUpProfile: "Iniciando monitoramento de @%{handle}...",
  billingContinueInAppTitle: "Continue no app Stalkie",
  billingContinueInAppBody: "A busca web verifica a disponibilidade do perfil. No app Stalkie, você acompanha o monitoramento completo e recebe alertas de follows e unfollows.",

  // Monitoring status
  monitoringActive: "Ativo",
  monitoringPaused: "Pausado",
  monitoringPrivate: "Privado",
  monitoringRateLimited: "Limitado",
  monitoringDisabled: "Desativado",
  monitoringPendingFirstSync: "Aguardando primeira sincronização",
  monitoringDegraded: "Degradado",
  monitoringError: "Erro",
  monitoringNextUpdate: "Próxima atualização: %{time}",

  // Timeline events
  timelineStartedFollowing: "Começou a seguir",
  timelineStoppedFollowing: "Deixou de seguir",
  timelineGainedFollower: "Novo seguidor",
  timelineLostFollower: "Perdeu seguidor",
  timelinePendingConfirmation: "Confirmação pendente",
  timelineLowConfidence: "Baixa confiança",
  timelineDiscarded: "Descartado",
  timelineNoEvents: "Nenhum evento ainda",
  timelineNoEventsHint: "Os eventos aparecem aqui quando o monitoramento detecta mudanças.",
  timelineEventsRetention: "Eventos são mantidos por até 90 dias.",
  timelineMonitoringStarted: "Monitoramento iniciado",
  timelineDataGap: "Lacuna de dados — sem dados confiáveis neste período",

  // App shell
  appDashboard: "Visão geral",
  appProfiles: "Perfis",
  appTimeline: "Linha do tempo",
  appBilling: "Assinatura",
  appAccount: "Configurações",
  appNotifications: "Notificações",
  notificationsEmptyTitle: "Está tudo em dia",
  notificationsEmptyBody: "Novas atividades de follow aparecerão aqui.",
  notificationsUnavailableTitle: "As notificações estão temporariamente indisponíveis.",
  notificationsUnavailableBody:
    "Sua conta continua segura. Volte ao painel e tente novamente em instantes.",
  notificationsBackToDashboard: "Voltar ao painel",
  settingsEmailNotifications: "Fallback por e-mail",
  settingsEmailNotificationsDesc: "Receba um e-mail se o push do navegador não estiver disponível.",
  notificationsMarkAllRead: "Marcar tudo como lido",
  appNavigation: "Navegação do app",
  appSignOut: "Sair",

  // Dashboard
  dashboardTitle: "Perfis monitorados",
  dashboardOverviewTitle: "Detecte follows suspeitos",
  dashboardEyebrow: "Alertas de follows",
  dashboardOverviewSubtitle: "Adicione um perfil público do Instagram para ver novos follows, unfollows e receber alertas.",
  dashboardMonitoringChip: "Monitorando",
  dashboardEmpty: "Descubra follows suspeitos. Pare de adivinhar.",
  dashboardEmptyHint: "Adicione um perfil público do Instagram para monitorar novos follows e unfollows. 100% anônimo.",
  dashboardEmptyProof: "100% Anônimo",
  dashboardFeatureNewFollows: "Novos follows detectados",
  dashboardFeatureUnfollows: "Unfollows detectados",
  dashboardAddProfile: "Adicionar perfil",
  dashboardAccountLimit: "%{current}/%{limit} perfis",
  dashboardUpgradeCta: "Assinar para adicionar mais",
  renewalTitle: "Reativar monitoramento",
  renewalDescription: "Seu plano anterior não está mais ativo. Renove para adicionar perfis e continuar recebendo alertas.",
  renewalCta: "Renovar plano",
  onboardingTargetTitle: "Qual perfil você quer monitorar?",
  addTargetSubtitle: "Cole um usuário ou link de perfil do Instagram. O Stalkie só monitora perfis públicos e começa a acompanhar a partir de agora.",
  addTargetModalTitle: "Confirmar",
  addTargetClipboardPaste: "Colar @%{handle}",
  addTargetPrivateError: "Este perfil é privado. O Stalkie só monitora perfis públicos do Instagram.",
  loadingAddMonitorTitle: "Adicionando perfil",
  loadingAddMonitorSubtitle: "Preparando monitoramento...",
  loadingAddMonitorStep1: "Verificando perfil",
  loadingAddMonitorStep2: "Iniciando monitoramento",
  loadingAddMonitorStep3: "Finalizando configuração",
  // Billing
  billingTitle: "Assinatura",
  billingCurrentPlan: "Plano atual",
  billingFree: "Grátis",
  billingManage: "Gerenciar assinatura",
  billingExpiresAt: "Renova ou expira em %{date}",
  billingSignInTitle: "Entre para gerenciar a assinatura",
  billingSignInBody: "Crie uma conta para assinar e começar a monitorar perfis.",
  billingNoSubscription: "Nenhuma assinatura ativa",
  billingCheckoutError: "Não foi possível abrir a tela de pagamento. Tente novamente.",
  billingPortalError: "Não foi possível abrir o gerenciamento da assinatura. Tente novamente.",
  billingRenewKicker: "Plano necessário",
  billingRenewTitle: "Mantenha o monitoramento ativo",
  billingRenewTitleTarget: "Começar a monitorar @%{handle}",
  billingRenewBody: "Escolha um plano para adicionar perfis, receber alertas e manter o monitoramento rodando.",
  billingRenewBodyTarget: "Escolha um plano para adicionar @%{handle} e começar a rastrear novos follows a partir de agora.",
  billingRenewIntro: "O monitoramento só fica disponível com um plano ativo. Sua conta continua pronta; escolha um plano para reativar o acompanhamento.",
  billingRenewIntroTarget: "Depois do pagamento, @%{handle} entra direto no monitoramento.",
  billingIncluded: "Incluído",
  billingFeatureAnonymous: "Monitoramento anônimo",
  billingFeatureAlerts: "Alertas de follows e unfollows",
  billingFeatureDirect: "Adição direta do perfil",
  billingPlanWeeklyMeta: "Até %{count} perfis, cobrança semanal",
  billingPlanMonthlyMeta: "Até %{count} perfis, cobrança mensal",
  billingStartTarget: "Começar @%{handle}",
  statusActive: "Ativo",

  // Account
  accountTitle: "Conta",
  settingsTitle: "Configurações",
  settingsNotifications: "Notificações",
  settingsNotificationsDesc: "Receber alertas de novos follows e unfollows",
  settingsSupport: "Suporte",
  settingsHelp: "Central de ajuda",
  settingsReport: "Reportar um problema",
  settingsAbout: "Sobre",
  settingsUserId: "ID do usuário",
  settingsVersion: "Versão",
  settingsLegal: "Legal",
  settingsTerms: "Termos de uso",
  settingsPrivacy: "Política de privacidade",
  settingsDeleteAccount: "Excluir conta",
  settingsDeleteAccountDesc: "Esta ação é irreversível",
  settingsCopied: "Copiado",
  accountNotificationsSaved: "Preferências de notificação atualizadas.",
  accountNotificationsError: "Não foi possível atualizar as notificações. Tente novamente.",
  accountNotificationsBlocked: "As notificações estão bloqueadas pelo seu navegador. Ative-as nas configurações do navegador.",
  accountNotificationsNotSupported: "Notificações push não são suportadas por este navegador.",
  accountCopyError: "Não foi possível copiar o ID neste navegador.",
  accountDeleteError: "Não foi possível excluir a conta. Tente novamente ou fale com suporte.",
  accountDeleteSubscriptionWarning: "Excluir sua conta não cancela sua assinatura ativa.",
  accountLanguage: "Idioma",
  accountLanguagePt: "Português",
  accountLanguageEn: "English",
  accountLanguageEs: "Español",
  accountSignInTitle: "Faça login para gerenciar sua conta",
  accountSignInBody: "Crie uma conta para começar.",
  accountSession: "Sessão",
  accountCreated: "Criado em %{date}",
  accountDeleteBtn: "Excluir conta",
  accountDeleteConfirmText: "Esta ação é irreversível. Todos os seus dados de monitoramento serão excluídos.",
  accountDeleteConfirmBtn: "Confirmar exclusão",
  accountCancel: "Cancelar",
  accountSubscriptionStatus: "Status: %{status}",
  accountSubscriptionLimit: "Limite de perfis: %{count}",

  // Dashboard Page additions
  dashboardErrorLoad: "Falha ao carregar perfis monitorados.",
  dashboardSignInTitle: "Faça login para ver seu painel",
  dashboardSignInBody: "Crie uma conta para começar a monitorar perfis.",

  // Profile Detail Page additions
  profileDetailRemoved: "Este perfil pode ter sido removido.",
  profileDetailRemoveBtn: "Remover monitoramento",
  tabFollows: "Novos follows",
  statNew: "Novos",
  tabUnfollows: "Unfollows",
  monitorDetailsMonitoringStarted: "Monitoramento ativo",
  monitorDetailsMonitoringStartedHint: "Novos follows aparecem aqui assim que o Stalkie detectar uma mudança confiável.",
  monitorDetailsRecentActivity: "Atividade recente",
  monitorDetailsPrivateWaiting: "Este perfil está privado agora. O Stalkie mantém o monitoramento pausado até a conta voltar a ser pública.",
  monitorDetailsDeleteDescription: "Isso remove o perfil da sua lista de monitoramento. Os dados existentes desse perfil serão excluídos.",
  monitorDetailsDeleteConfirm: "Excluir",
  monitorDetailsDeleteError: "Não foi possível remover este monitoramento. Tente novamente.",
  emptyUnfollows: "Nenhum unfollow detectado",
  activityHoursTitle: "Padrão de atividade",

  // Timeline Filter additions
  timelineFilterAll: "Todos",
  timelineFilterFollows: "Follows",
  timelineFilterUnfollows: "Unfollows",

  // Common
  commonBack: "Voltar",
  commonClose: "Fechar",
  commonLoading: "Carregando...",
  commonError: "Algo deu errado",
  commonRetry: "Tentar novamente",
  commonLoadMore: "Carregar mais",
  profileUpdatedAt: "Atualizado %{time}",
  commonNever: "nunca",
  commonJustNow: "agora mesmo",
  commonMinutesAgo: "há %{minutes}min",
  commonHoursAgo: "há %{hours}h",
  commonDaysAgo: "há %{days}d",
  commonFollowing: "seguindo",
  commonFollowers: "seguidores",

  // Empty / error states
  emptyProfilesTitle: "Nenhum perfil para mostrar",
  emptyProfilesBody: "Você ainda não adicionou perfis para monitorar.",
  errorGenericTitle: "Algo deu errado",
  errorGenericBody: "Um erro inesperado ocorreu. Tente novamente.",
  errorNetworkTitle: "Problema de conexão",
  errorNetworkBody: "Verifique sua conexão de internet e tente novamente.",

  // Login
  loginBackToHome: "← Voltar para a página inicial",
  loginWelcomeBack: "Bem-vindo de volta",
  loginSubtitle: "Faça login para ver seus perfis monitorados, alterações recentes e alertas.",
  loginEmailLabel: "Endereço de e-mail",
  loginEmailPlaceholder: "voce@exemplo.com",
  loginSendingCode: "Enviando código…",
  loginContinueBtn: "Continuar com e-mail",
  loginFooterNote: "Use o mesmo e-mail conectado ao seu aplicativo Stalkie. Enviaremos um código único — sem necessidade de senha.",
  loginBack: "Voltar",
  loginCheckEmail: "Verifique seu e-mail",
  loginSentCodeTo: "Enviamos um código de 6 dígitos para",
  loginLoggingIn: "Entrando…",
  loginResendCode: "Reenviar código",
  loginSendAgain: "Enviar novamente",
  loginNeedHelp: "Precisa de ajuda?",
  loginContactSupport: "Contatar suporte",
  loginErrorSend: "Não foi possível enviar seu código. Verifique seu e-mail e tente novamente.",
  loginErrorVerify: "Esse código não funcionou. Verifique o código e tente novamente.",
  loginErrorResend: "Falha ao reenviar. Tente novamente.",
  loginSubmitBtn: "Entrar",

  // 404
  notFoundTitle: "Esta página não existe.",
  notFoundGoHome: "Voltar para o início",

  // Parity / Dossier keys
  dossierTitle: "Detalhes do Perfil",
  dossierMutual: "Seguem-se mutuamente",
  dossierFollowers: "Seguidores",
  dossierFollowing: "Seguindo",
  dossierPrivate: "Perfil Privado",
  dossierPublic: "Perfil Público",
  dossierViewOnInstagram: "Ver no Instagram",
  genderBreakdownTitle: "Análise de gênero dos follows",
  genderBreakdownText: "Seguiu recentemente: %{female} garotas, %{male} garotos, %{unknown} outros",
  genderBreakdownFemale: "%{count} garotas",
  genderBreakdownMale: "%{count} garotos",
  genderBreakdownUnknown: "%{count} outros",
  genderBreakdownNone: "Nenhum follow detectado ainda",
  mutualBadge: "Mútuo",
  dossierCategoryPersonal: "Conta Pessoal",
  dossierCategoryInfluencer: "Influenciador",
  dossierCategoryCreator: "Criador de Conteúdo",
  dossierCategoryBrand: "Marca / Empresa",
};

export default pt;
